enum ApiError {
  Forbidden = 403,
  Conflict = 409,
}

export default ApiError;
